// /** @typedef {InstanceType<typeof import("../nshop-orders.model").NshopOrder>} $NshopOrder */
/** @typedef {import("../nshop-orders.inits").NshopOrder} $NshopOrder */

import { NSHOP_ORDER_PAYMENT_METHODS } from "../nshop-orders.const";

export class NshopOrderAider {
    /**
     * 최소수량 계산
     * 최소 구매금액(5만원) 제한은 openbank(내 통장 결제)에만 적용된다. 그 외 수단은 하한 없음(1개).
     * @param {$NshopOrder} data
     */
    static calcCountMin(data) {
        switch (data?.payment?.method) {
            case "openbank": {
                return Math.ceil(50000 / data?.price?.unit);
            }

            default: {
                return 1;
            }
        }
    }

    /**
     * 최대수량 계산
     * @param {$NshopOrder} data
     */
    static calcCountMax(data) {
        switch (data?.payment?.method) {
            case "card": {
                return Math.floor((1000000 - 35000) / data?.price?.unit);
            }

            case "openbank": {
                return Math.floor(500000 / data?.price?.unit);
            }

            default: {
                return Math.floor(2000000 / data?.price?.unit);
            }
        }
    }
    /**
     * 전체금액 계산
     * @param {$NshopOrder} data
     */
    static calcPrice(data) {
        let price = { ...data.price };

        price.sum = this.calcPriceSum(data);
        price.fee = this.calcPriceFee(data, price.sum);
        price.sale = this.calcPriceSale(data, price.sum, price.fee);

        return price;
    }

    /**
     * 소계금액 계산
     * @param {$NshopOrder} data
     */
    static calcPriceSum(data) {
        return data.price.unit * data.count;
    }

    /**
     * 수수료 계산
     * @param {$NshopOrder} form
     * @param {number} [sum]
     */
    static calcPriceFee(form, sum) {
        switch (form.payment.method) {
            case "card": {
                if (!sum) sum = this.calcPriceSum(form);
                return sum * 0.035;
            }
            default: {
                return 0;
            }
        }
    }

    /**
     * 판매가 계산
     * @param {$NshopOrder} form
     * @param {number} [sum]
     * @param {number} [fee]
     */
    static calcPriceSale(form, sum, fee) {
        if (!sum) sum = this.calcPriceSum(form);
        if (!fee) fee = this.calcPriceFee(form);
        return sum - fee;
    }

    /**
     * 유효성 검사
     * @param {$NshopOrder} data
     */
    static async test(data) {
        if (!data.payment.method) throw new Error("결제수단을 선택하세요");

        let paymentMethodError = !NSHOP_ORDER_PAYMENT_METHODS[data.payment.method]?.uses;
        if (paymentMethodError) throw new Error("결제 수단이 잘못되었습니다");

        if (![10000, 30000, 50000].includes(data.price.unit)) throw new Error("권종이 잘못되었습니다");

        let countMax = this.calcCountMax(data);
        if (countMax < data.count) throw new Error("구매 수량이 잘못되었습니다");

        let countMin = this.calcCountMin(data);
        if (data.count < countMin) {
            switch (data.payment.method) {
                case "openbank": {
                    throw new Error("결제 금액이 5만원 이상이어야 결제가 가능합니다.\n개수를 늘려 5만원 이상 구매해주세요.");
                }

                default: {
                    throw new Error("구매 수량이 잘못되었습니다");
                }
            }
        }

        let price = this.calcPrice(data);

        let priceError = Object.entries(price).some(([key, value]) => data.price[key] !== value);
        if (priceError) throw new Error("구매 금액이 잘못되었습니다");
    }
}
